import React from 'react';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import './NoVideoSelected.pcss';

const NoVideoSelected: React.FC = () => {
  return (
    <div className="NoVideoSelected">
      <FormattedMessageWrapper langKey="web.youtube_playlist.no_video_selected" />
    </div>
  );
};

export default NoVideoSelected;
